/* ImportAction.js */

"use strict";

class ImportAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        DeviceEntity,
        OsUpgradePlan,
        userSession,
        activityMonitor,
        activeView
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._userSession = userSession;
        this._deviceEntity = DeviceEntity;
        this._osPlan = OsUpgradePlan;
        this._modalUserFeedback = this._gameEditor._modalUserFeedback;
        this._activeView = activeView;
        this._activityMonitor = activityMonitor;
        this.run = this.run.bind(this);
    }

    run() {
        console.log("Upload file..");
    }
}

module.exports = ImportAction;

ImportAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.Device",
    "$teve.entities.OdmOsUpgradePlan", // Changed from OdmOsUpdatePlan
    "$teve.userSession",
    "$teve.activityMonitor",
    "gameEditor.activeView",
];

ImportAction.$displayDetails = {
    type: "Action",
    name: "ConfigureAuditAction",
    icon: "osmanager.run_os_plans",
    shown: true,
    title: "Import IoT OS Plan results",
    order: 1,
};
